// Create this file: src/pages/TestPayment.js
// This tests both UpgradeModal and Payment flow

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UpgradeModal from '../components/UpgradeModal';

const TestPayment = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  // Test direct navigation to payment
  const testDirectPayment = () => {
    navigate('/payment', {
      state: {
        tier: {
          id: 'paid',
          name: 'Paid',
          icon: '💎',
          price: 2.99,
          features: [
            '3 Personas',
            '8 Sequences',
            '15 Daily predictions'
          ]
        }
      }
    });
  };

  return (
    <div style={{ 
      padding: '2rem', 
      maxWidth: '800px', 
      margin: '0 auto',
      minHeight: '100vh',
      background: '#1a0b2e',
      color: 'white'
    }}>
      <h1>🧪 Payment Flow Test</h1>
      
      <div style={{ 
        background: 'rgba(168, 85, 247, 0.1)', 
        padding: '2rem', 
        borderRadius: '12px',
        marginBottom: '2rem'
      }}>
        <h2>Test 1: Upgrade Modal</h2>
        <p>This should open the upgrade modal with tier options</p>
        <button
          onClick={() => setShowModal(true)}
          style={{
            padding: '1rem 2rem',
            background: 'linear-gradient(135deg, #8b5cf6, #a855f7)',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginTop: '1rem'
          }}
        >
          Open Upgrade Modal
        </button>

        {showModal && (
          <div style={{ marginTop: '1rem', color: '#10b981' }}>
            ✓ Modal state is TRUE
          </div>
        )}
      </div>

      <div style={{ 
        background: 'rgba(168, 85, 247, 0.1)', 
        padding: '2rem', 
        borderRadius: '12px',
        marginBottom: '2rem'
      }}>
        <h2>Test 2: Direct Payment Page</h2>
        <p>This should navigate directly to the payment page</p>
        <button
          onClick={testDirectPayment}
          style={{
            padding: '1rem 2rem',
            background: 'linear-gradient(135deg, #8b5cf6, #a855f7)',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginTop: '1rem'
          }}
        >
          Go to Payment Page
        </button>
      </div>

      <div style={{ 
        background: 'rgba(168, 85, 247, 0.1)', 
        padding: '2rem', 
        borderRadius: '12px'
      }}>
        <h2>Test 3: Success Page</h2>
        <p>This should navigate to the success page</p>
        <button
          onClick={() => navigate('/payment-success', {
            state: {
              tier: 'Paid',
              amount: 2.99,
              paymentIntent: { id: 'test_123' }
            }
          })}
          style={{
            padding: '1rem 2rem',
            background: 'linear-gradient(135deg, #8b5cf6, #a855f7)',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginTop: '1rem'
          }}
        >
          Go to Success Page
        </button>
      </div>

      <div style={{ 
        marginTop: '2rem',
        padding: '1rem',
        background: 'rgba(239, 68, 68, 0.1)',
        borderRadius: '8px',
        fontSize: '0.9rem'
      }}>
        <h3>Debug Info:</h3>
        <p>Modal state: {showModal ? 'OPEN' : 'CLOSED'}</p>
        <p>Current path: {window.location.pathname}</p>
        <p>React Router: {typeof navigate === 'function' ? '✓ Working' : '✗ Not working'}</p>
      </div>

      {/* The Modal */}
      <UpgradeModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        currentTier="free"
      />
    </div>
  );
};

export default TestPayment;